import { render, staticRenderFns } from "./dialog-loginsso.vue?vue&type=template&id=1b10b2ca&"
import script from "./dialog-loginsso.vue?vue&type=script&lang=js&"
export * from "./dialog-loginsso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports